export enum OrderItemEntryStatus {
  RESERVED = "RESERVED",
  SOLD = "SOLD",
  VOIDED = "VOIDED",
  RETURNED = "RETURNED" // New status for returned items
}
